import { PencilIcon } from "@heroicons/react/solid";
import { useEffect, useRef, useState } from "react";
import { H2RButton, H2RHeading } from "../imports";

import { cuesApi } from "../imports";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function ProjectName({ name, selectedProject, size = "h2" }) {
	const [editing, setEditing] = useState(false);
	const [n, setN] = useState(name);

	const projectNameInput = useRef();

	const handleNameChange = () => {
		if (n === "") {
			setN(name);
			return setEditing(false);
		}

		cuesApi.renameProject(selectedProject, n);
		setEditing(false);
	};

	useEffect(() => {
		setN(name);
	}, [name]);

	useEffect(() => {
		if (editing === true) {
			projectNameInput.current.focus();
			projectNameInput.current.select();
		}
	}, [editing]);

	return (
		<>
			<H2RHeading type={size}>
				{editing === false ? (
					<button
						title="Edit project name"
						className="cursor-text flex space-x-2 items-center w-100 group"
						onClick={() => {
							console.log("should edit");
							return setEditing(true);
						}}
					>
						{n}
						<PencilIcon className="ml-2 h-5 w-5 text-gray-300 cursor-pointer opacity-0 group-hover:opacity-100" />
					</button>
				) : (
					<div className="flex space-x-2">
						<input
							ref={projectNameInput}
							className="w-64 bg-transparent focus:outline-none focus:ring rounded"
							value={n}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									return handleNameChange();
								}
							}}
							onChange={(e) => {
								setN(e.target.value);
							}}
						/>
						<H2RButton
							text="Done"
							colour="light"
							icon={faCheck}
							size="small"
							onClick={handleNameChange}
						/>
					</div>
				)}
			</H2RHeading>
		</>
	);
}
